import { Helmet } from "react-helmet-async";

const SITE_NAME = "CityWorth Benefits";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_38ff7071-66f9-4d88-af35-8aea95a1b115/artifacts/bd4gpi71_9c1704e9-a2fd-4116-bbdf-40383e1a2ed8.png";

const SEO = ({ title, description, image }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1536" />
      <meta property="og:image:height" content="1024" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default SEO;
